export enum ApplicationContextValues {
  Public = "public",
  DigitalOffice = "digital-office",
}
